var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Medal = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M16.5 15V22.5L12 20.25L7.5 22.5V15M19.5 9C19.5 13.1421 16.1421 16.5 12 16.5C7.85786 16.5 4.5 13.1421 4.5 9C4.5 4.85786 7.85786 1.5 12 1.5C16.1421 1.5 19.5 4.85786 19.5 9ZM16.5 9C16.5 11.4853 14.4853 13.5 12 13.5C9.51472 13.5 7.5 11.4853 7.5 9C7.5 6.51472 9.51472 4.5 12 4.5C14.4853 4.5 16.5 6.51472 16.5 9Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
